var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "New - Logo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.966 18.0394L98.7847 14.2207C112.235 25.6164 120 42.3567 120 60C120 93.115 93.1148 120 60 120C26.885 120 0 93.1148 0 60C0 26.885 26.8852 0 60 0C69.4686 0 78.8028 2.24094 87.2394 6.5396L87.0226 6.96512L71.7121 22.2755C67.9316 21.1018 63.9839 20.4992 60 20.4992C38.1989 20.4992 20.4992 38.199 20.4992 60C20.4992 81.8011 38.199 99.5008 60 99.5008C81.8011 99.5008 99.5008 81.801 99.5008 60C99.5008 54.8697 98.5035 49.8553 96.627 45.209L60.0056 81.8304L36.0852 57.91L50.4967 43.4985L60.0055 53.0072L94.9291 18.0836L94.966 18.0394Z",
    fill: "#27AB83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/new-logo.93aa637a1c4a958eefcf7eb6469279c2.svg";
export { ForwardRef as ReactComponent };